
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo",
      function () {
        return require("private-next-pages/photo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo"])
      });
    }
  